import { useEffect } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { AtpLib } from 'atp-react-ui';
import TagManager from 'react-gtm-module';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import PagePreLoader from '@/_components/preloader';
import { isProductionEnv } from '@/_static/constants';
import { queryClient, initChat } from '@/_utils';

import router from './root-router';

const tagManagerArgs = {
  gtmId: 'GTM-P553SFXV',
};

/**
 * info: 
 * Entry point for app logic
 * All global initializations and declarations are done here
  
 * <PersistGate:  Initialize State persistor
 * <ThemeProvider: Provide theme context to all code
 * <CssBaseline: Initialize all base css for old browsers
 * <ErrorBoundary: Capture unwanted bugs
 */

function EntryPoint() {
  if (isProductionEnv) {
    TagManager.initialize(tagManagerArgs);
  }

  useEffect(() => {
    document.getElementById('preloader').style.display = 'none';
    initChat();
  }, []);

  return (
    <AtpLib usePreferences={false} preferredMode="light">
      <QueryClientProvider client={queryClient}>
        <ToastContainer
          limit={5}
          position="bottom-left"
          autoClose={6000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnHover
        />

        <RouterProvider
          router={router}
          future={{
            v7_startTransition: true,
          }}
          fallbackElement={
            <div className="bg-primary-xx-light">
              <PagePreLoader fullScreen />
            </div>
          }
        />
      </QueryClientProvider>
    </AtpLib>
  );
}

export default EntryPoint;
